import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeHide = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 19.8C8 19.8 12.8 11.4 20 11.4C27.2 11.4 32 19.8 32 19.8C32 19.8 27.2 28.2 20 28.2C12.8 28.2 8 19.8 8 19.8Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 23.4C21.9882 23.4 23.6 21.7882 23.6 19.8C23.6 17.8118 21.9882 16.2 20 16.2C18.0118 16.2 16.4 17.8118 16.4 19.8C16.4 21.7882 18.0118 23.4 20 23.4Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.20001 30.6L30.8 9",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgEyeHide);
export default ForwardRef;
